/*
 *
 * Error constants
 *
 */

export const BASE_ACTION_CONSTANT = 'app/Error';

export const DEFAULT_ACTION = `${BASE_ACTION_CONSTANT}/DEFAULT_ACTION`;

export const SHOW_TOAST = `${BASE_ACTION_CONSTANT}/Error/SHOW_TOAST`;

export const HIDE_TOAST = `${BASE_ACTION_CONSTANT}/HIDE_TOAST`;

export const RESET_ERROR_TITLE = `${BASE_ACTION_CONSTANT}/RESET_ERROR_TITLE`;

export const RESET_TWO_FACTOR_VERIFICATION = `${BASE_ACTION_CONSTANT}/RESET_TWO_FACTOR_VERIFICATION`;
